'use strict';

var viewportUnitsBuggyfill = require('viewport-units-buggyfill'),
    { any } = require('underscore');

// Polyfill calls are wrapped in try-catch to avoid potential issues in IE:
// https://github.com/rodneyrehm/viewport-units-buggyfill/issues/38

try {
  viewportUnitsBuggyfill.init();
} catch (err) { }

var patchedViewportStyleNode = document.getElementById('patched-viewport');

function isAppStyleNode(node) {
  return node.tagName === 'STYLE' && node !== patchedViewportStyleNode;
}

function refreshViewportBuggyfill() {
  try {
    viewportUnitsBuggyfill.refresh();
    patchedViewportStyleNode.parentNode.appendChild(patchedViewportStyleNode);
  } catch (err) { }
}

function handleHeadMutation(mutationRecords) {
  if (any(mutationRecords, record => any(record.addedNodes, isAppStyleNode))) {
    refreshViewportBuggyfill();
  }
}

if (patchedViewportStyleNode) {
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(handleHeadMutation).observe(document.head, {
      childList: true
    });
  } else {
    setInterval(refreshViewportBuggyfill, 1500);
  }
}


/** WEBPACK FOOTER **
 ** ./utils/polyfills/viewportUnits.js
 **/